var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ranking-board-title"},[_c('img',{attrs:{"src":require("../../assets/images/ic_arrow.png")}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.pageTotal>1)?_c('span',{staticClass:"pager"},[_vm._v(_vm._s(_vm.pageIndex)+"/"+_vm._s(_vm.pageTotal))]):_vm._e()]),_c('div',{staticClass:"title-border"})])
}
var staticRenderFns = []

export { render, staticRenderFns }